// 
// -----------------------------------------------------------------------------
(function ($book) {
	if ($book.length === 0) {return false;}

	$book.prependTo('body');

	var $leftSidebar = $('.left-sidebar');
	var $rightside = $('.white-content');
	var $content = $('.ttt');
	var bottomSidebar = $leftSidebar.offset().top + $leftSidebar.outerHeight();
	var bottomContent = $content.offset().top + $content.outerHeight();
	var leftSidebarPos = $rightside.offset().left;

	function buttonPos(){
		$book.css({
			'left' : leftSidebarPos,
			'marginLeft' : '-175px'
		});
	}

	buttonPos();

    $( window ).resize(function() {
    	leftSidebarPos = $rightside.offset().left;
    	buttonPos();
    });

    $(window).scroll(function() {
        var height = $(window).scrollTop();

        if (matchMedia) {
          var mq = window.matchMedia("(min-width: 992px)");
          mq.addListener(WidthChange);
          WidthChange(mq);
        }

        function WidthChange(mq) {
          if (mq.matches) {
	        if(height  > ( bottomSidebar - '200') && height < ( bottomContent - '350')) {
	            $book.show();
	        } else {
	        	$book.hide();
	        }
          } else {
      		$book.hide();
          }
        }
    });




	$( '.book-now').click(function (e) {
		e.preventDefault();
		$('html, body').animate({
        scrollTop: $content.offset().top
    }, 1000);
	});

})($( '.book-now-wrap' ));